/**
 * Baixa um PDF gerado pelo backend (GET autenticado). Usa o nome sugerido pelo
 * servidor (Content-Disposition) e cai no `fallbackName` se não vier.
 */
export async function downloadPdf(api, path, fallbackName = "documento.pdf") {
  const res = await api.get(path, { responseType: "blob" });
  const cd = res.headers?.["content-disposition"] || "";
  const name = (cd.match(/filename="?([^";]+)"?/) || [])[1] || fallbackName;
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
